import './missingInfo.scss';

interface MissingClientProps {
  image: string;
  boxTitle: string;
  messageTitle: string;
  messageText: string;
  showTitle?: boolean;
}

const MissingClientInfo = ({
  image,
  boxTitle,
  messageTitle,
  messageText,
  showTitle = true,
}: MissingClientProps) => (
  <>
    {showTitle && <div className="box_title">{boxTitle}</div>}
    <div className="items-center justify-center mx-auto mt-30 my-5">
      <div className="my-10">
        <img
          src={image}
          alt="missing-data"
          className="w-auto max-w-fit h-full"
        />
      </div>
      <div className="message_title">{messageTitle}</div>
      <div className="message_text">{messageText}</div>
    </div>
  </>
);

export default MissingClientInfo;
